import { Bem, BemDecl } from './Bem/Bem';

const prefix = 'test--';

export class TestBem {
    static cls(decl: BemDecl | string, elem?: string, mods?: { [modName: string]: string | boolean }): string {
        return typeof decl === 'string'
            ? Bem.cls({ block: `${prefix}${decl}`, elem, mods })
            : Bem.cls({
                  ...decl,
                  block: `${prefix}${decl.block}`
              });
    }
}
